export default "__VITE_ASSET__Cb3twol4__"